import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

const LazyLoad = ({ placeholder, threshold, children }) => {
  // load images by default if intersection observer is not available
  const visibleByDefault =
    typeof window !== 'undefined' &&
    !(
      'IntersectionObserver' in window &&
      'isIntersecting' in window.IntersectionObserverEntry.prototype
    )

  return (
    <LazyLoadComponent
      placeholder={placeholder}
      threshold={threshold}
      visibleByDefault={visibleByDefault}
    >
      {children}
    </LazyLoadComponent>
  )
}

LazyLoad.propTypes = {
  placeholder: PropTypes.element,
  threshold: PropTypes.number,
  children: PropTypes.element.isRequired,
}

LazyLoad.defaultProps = {
  placeholder: null,
  threshold: null,
}

export default LazyLoad
